var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirplane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.80498 3.09761C9.65253 2.7927 9.34089 2.6001 9 2.6001C8.6591 2.6001 8.34747 2.7927 8.19501 3.09761L1.89501 15.6976C1.7354 16.0168 1.7795 16.4002 2.00744 16.6749C2.23538 16.9495 2.60407 17.0635 2.94725 16.9655L7.44724 15.6798C7.83361 15.5694 8.09999 15.2162 8.09999 14.8144V10.7001C8.09999 10.203 8.50293 9.8001 8.99999 9.8001C9.49704 9.8001 9.89999 10.203 9.89999 10.7001V14.8144C9.89999 15.2162 10.1664 15.5694 10.5527 15.6798L15.0527 16.9655C15.3959 17.0635 15.7646 16.9495 15.9926 16.6749C16.2205 16.4002 16.2646 16.0168 16.105 15.6976L9.80498 3.09761Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirplane);
export default __webpack_public_path__ + "static/media/airplane.50760f6c017d95e920dd395398545467.svg";
export { ForwardRef as ReactComponent };